import React, { FC } from 'react';
import { Button } from 'antd';
import cn from 'classnames';
import MenuDropdown from '../MenuDropdown';
import SubMenu from '../SubMenu';
import { INavButton, ILink } from '../../types';
import './styles.scss';

interface IMainMenu {
  logo?: React.ReactNode;
  title: string;
  menuButtons: INavButton[];
  additionalLinks?: ILink[];
  subMenuButtons?: INavButton[];
}

const MainMenu: FC<IMainMenu> = ({
  additionalLinks = [],
  title,
  menuButtons,
  subMenuButtons,
  logo = undefined,
}) => {
  return (
    <section className='hbh-main-menu-container'>
      <div className='hbh-menu-panel'>
        <div className='hbh-menu-panel-header'>
          <div className='logo'>{logo}</div>
          <h2 className='title'>{title}</h2>
          <MenuDropdown links={additionalLinks} />
        </div>
        <div className='hbh-menu-panel-content'>
          {menuButtons.map((button) => {
            return (
              <Button
                size='large'
                key={button.label}
                icon={button.icon}
                onClick={button.onClick}
                className={cn('hbh-menu-button', button?.className)}
              >
                {button.label}
              </Button>
            );
          })}
          {subMenuButtons?.length && <SubMenu subMenuButtons={subMenuButtons} />}
        </div>
      </div>
    </section>
  );
};

export default MainMenu;
